// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5919932a","239":"dff5e27f","667":"e7f8c2ff"}[chunkId] + ".chunk.js";
};